// Styling

// Components
import Button from "@/components/button/button";

export default function Pagination(props) {
  // Variables
  const { pagData, setPag, type, loading } = props;
  const disablePrev = loading || !pagData.hasPreviousPage;
  const disableNext = loading || !pagData.hasNextPage;

  return (
    <div className="pagination" data-type={type}>
      {/* {pagData.hasPreviousPage && ( */}
      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault();
          setPag.setPagBefore(pagData.startCursor);
          setPag.setPagAfter(null);
        }}
      >
        <Button
          className="prevBtn btn"
          type="submit"
          disabled={disablePrev}
          ariaAtts={{ "aria-label": "Load previous set of posts" }}
        >
          {loading ? "Loading..." : "Previous"}
        </Button>
      </form>
      {/* )} */}
      {/* {pagData.hasNextPage && ( */}
      <form
        method="post"
        onSubmit={(e) => {
          e.preventDefault();
          setPag.setPagAfter(pagData.endCursor);
          setPag.setPagBefore(null);
        }}
      >
        <Button
          className="nextBtn btn"
          type="submit"
          disabled={disableNext}
          ariaAtts={{ "aria-label": "Load next set of posts" }}
        >
          {loading ? "Loading..." : "Next"}
        </Button>
      </form>
      {/* )} */}

      {/* { TODO: Load more - append to page instead of replace} */}
      {/* {pagData.hasNextPage && (
        <form
          method="post"
          onSubmit={(e) => {
            e.preventDefault();
            setPag.setPagAfter(pagData.endCursor);
          }}
        >
          <Button type="submit" disabled={loading}>
            {loading ? "Loading..." : "Load more"}
          </Button>
        </form>
      )} */}
    </div>
  );
}
